import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerPwa } from './services/pwa';
import { captureAppContext } from './services/appContext';

// Inside the Android app? Must run before the first render (purchase UI is gated on it).
captureAppContext();

// react-snap prerenders public routes to static HTML at build time. When that
// HTML is present the root already has children, so we hydrate instead of doing
// a fresh client render (avoids throwing away the prerendered markup / a flash).
const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, <App />);
} else {
    createRoot(rootElement).render(<App />);
}

// Installable app + review reminder pushes (public/sw.js)
registerPwa();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
